import { render, staticRenderFns } from "./labelTag.vue?vue&type=template&id=6278a055&lang=pug"
import script from "./labelTag.vue?vue&type=script&lang=js"
export * from "./labelTag.vue?vue&type=script&lang=js"
import style0 from "./labelTag.vue?vue&type=style&index=0&id=6278a055&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports